export const styles = {
  root: {
    overflow: 'hidden',
  },
};
